<template>
  <div>
    <div v-if="!isMobile">
      <div class="border border-right-0">
        <div class="py-3 mb-3 specialist-list-title">
          <div class="m-3 font-weight-bold ">
            <div class="d-inline mr-2 specialist-list-title-icon">
              <i class="fas fa-user-circle text-white fa-lg" />
            </div>
            Filtrar Especialista
          </div>
        </div>
        <div class="mt-3">
          <div
            v-for="(item, key) in optionValues"
            :key="key"
            class="m-2 py-3 px-2 rounded specialist-list-item"
            :class="{
              'bg-gray-12 text-white selected': isItemSelected(item),
              'bg-spec-default': !isItemSelected(item) && canSelectSpecialist,
              'bg-secondary-5 text-gray-disabled border-left-disabled cursor-disabled':
                !isItemSelected(item) && !canSelectSpecialist,
              'specialist-license-expired': specialistLicenseExpired(item),
            }"
            @click="onSelect(item)"
          >
            <div class="row">
              <div class="col-3 pr-2 d-flex text-center justify-content-center">
                <div
                  class="d-inline specialist-list-item-icon"
                  :class="{
                    'specialist-list-item-icon-disabled':
                      !canSelectSpecialist && !isItemSelected(item),
                  }"
                >
                  <i
                    class="fas fa-user"
                    :class="{
                      'text-white': isItemSelected(item),
                      'text-orange':
                        !isItemSelected(item) && canSelectSpecialist,
                      'icon-disabled':
                        !isItemSelected(item) && !canSelectSpecialist,
                    }"
                  />
                </div>
              </div>
              <div class="col pl-0">
                <span class="d-block">
                  {{ item.name }}
                </span>
                {{ item.licenseNo }}
              </div>
              <div v-if="item.licenseExpired" class="pl-0 pr-4 pt-2">
                <button class="button-specialist-license-expired">
                  <i
                    class="fa fa-calendar-exclamation specialist-license-expired-icon"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasAdmissionSpaces">
          <div
            v-for="(item, key) in admission.spaces"
            :key="key"
            class="px-2 rounded"
          >
            <div class="card text-white bg-orange mb-2">
              <div class="card-body relative">
                <i
                  class="fa fa-times close-space mr-2 text-white"
                  @click="removeSpace(item, key)"
                />
                <div class="card-text ">
                  <div class="row ">
                    <div class="col-1">
                      <i class="fa fa-clock mr-2 text-white" />
                    </div>
                    <div class="col-9">
                      Día/Hora:
                      <br />
                      {{ item.day.name }},
                      <br />
                      <span class="fs-16">
                        {{
                          item.start.hour > 12
                            ? item.start.hour - 12
                            : item.start.hour
                        }}:{{ item.start.minute }} {{ item.start.type }} -
                        {{
                          item.end.hour > 12
                            ? item.end.hour - 12
                            : item.end.hour
                        }}:{{ item.end.minute }}
                        {{ item.end.type }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="rounded border bg-white py-4 px-2 shadow-sm pointer mb-0 position-relative"
        :class="[{ 'border-bottom-0': showSpecialistList }, {}]"
        @click="() => (showSpecialistList = !showSpecialistList)"
      >
        <div
          class="row m-0 p-0"
          :class="[
            {
              'bg-gray-12 text-white selected rounded py-2 border-left-orange':
                !showSpecialistList && value && canSelectSpecialist,
            },
          ]"
        >
          <div class="col-1 m-0">
            <div
              class="bg-white shadow d-flex justify-content-center align-content-center mr-2 rounded-circle icon"
              :class="!showSpecialistList && value ? 'bg-gray-12 ml-2' : 'p-1'"
            >
              <div
                class="d-flex justify-content-center align-content-center rounded-circle"
                :class="
                  !showSpecialistList && value ? 'bg-gray-12' : 'bg-orange'
                "
              >
                <i
                  v-if="!showSpecialistList && value"
                  class="fad fa-user-circle text-g font-30"
                  style="--fa-primary-color: #ffffff; --fa-secondary-color: #869193;"
                />
                <i
                  v-else
                  aria-hidden="true"
                  class="fa fa-user-circle text-white p-1"
                />
              </div>
            </div>
          </div>
          <div class="col-8">
            <p class="mt-1 d-flex flex-column">
              <span class="font-16 font-weight-bold">
                {{ value ? value.name : 'Filtrar Especialista' }}
              </span>
              <span
                v-if="!showSpecialistList && value"
                class="font-16 font-weight-bold"
              >
                {{ value && value.licenseNo }}
              </span>
            </p>
          </div>
          <div class="col">
            <i class="fas fa-chevron-down mr-3 icon" />
          </div>
        </div>
      </div>
      <div v-if="showSpecialistList" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div
              v-for="(item, key) in options"
              :key="key"
              class="m-2 py-3 px-2 rounded specialist-list-item"
              :class="{
                'bg-gray-12 text-white selected': isItemSelected(item),
                'bg-secondary-3': !isItemSelected(item),
                'specialist-license-expired': specialistLicenseExpired(item),
              }"
              @click="onSelect(item)"
            >
              <div class="row">
                <div
                  class="col-3 pr-2 d-flex text-center justify-content-center"
                >
                  <div class="d-inline specialist-list-item-icon">
                    <i
                      class="fas fa-user"
                      :class="{
                        'text-white': isItemSelected(item),
                        'text-orange': !isItemSelected(item),
                      }"
                    />
                  </div>
                </div>
                <div class="col pl-0">
                  <span class="d-block">
                    {{ item.name }}
                  </span>
                  {{ item.licenseNo }}
                </div>
                <div v-if="item.licenseExpired" class="pl-0 pr-4">
                  <button class="button-specialist-license-expired">
                    <i
                      class="fa fa-calendar-exclamation specialist-license-expired-icon"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasAdmissionSpaces">
        <div
          v-for="(item, key) in admission.spaces"
          :key="key"
          class="rounded mt-2"
        >
          <div class="card text-white bg-orange mb-2">
            <div class="card-body relative">
              <i
                class="fa fa-times close-space mr-2 text-white"
                @click="removeSpace(item, key)"
              />
              <div class="card-text ">
                <div class="row ">
                  <div class="col-1">
                    <i class="fa fa-clock mr-2 text-white" />
                  </div>
                  <div class="col-9">
                    Día/Hora:
                    <br />
                    {{ item.day.name }},
                    <br />
                    <span class="fs-16">
                      {{ item.start.hour }}:{{ item.start.minute }}
                      {{ item.start.type }} - {{ item.end.hour }}:{{
                        item.end.minute
                      }}
                      {{ item.end.type }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialistList',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => null,
    },
    admission: {
      type: Object,
      default: () => null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    isViewMode: {
      type: Boolean,
      default: false,
    },
    isAdmissionCoordination: {
      type: Boolean,
      default: false,
    },
    isCoordination: {
      type: Boolean,
      default: false,
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSpecialistList: false,
    };
  },
  computed: {
    isItemSelected() {
      return (item) => this.value && this.value.id == item.id;
    },
    hasAdmissionSpaces() {
      return this.admission && this.admission.spaces.length;
    },
    optionValues() {
      return this.hasAdmissionSpaces
        ? this.options.filter((x) => this.isItemSelected(x))
        : this.options;
    },
    canSelectSpecialist() {
      return (
        (!this.editMode &&
          !this.isCoordination &&
          this.isAdmissionCoordination) ||
        this.isViewMode ||
        this.isTransfer
      );
    },
  },
  mounted() {
    if (this.value) {
      this.onSelect(this.value);
    }
  },
  methods: {
    onSelect(item) {
      if (!this.canSelectSpecialist) {
        return;
      }
      this.showSpecialistList = false;
      this.admission?.spaces?.forEach((item, key) => {
        this.removeSpace(item, key);
      });
      if (!this.value) {
        this.$emit('input', item);
        return;
      }
      const value = this.value.id === item.id ? null : item;

      this.$emit('input', value);
    },
    removeSpace(item, index) {
      this.$emit('remove-admission-available-space', item, index);
    },
    specialistLicenseExpired(item) {
      return item && item.licenseExpired;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
@import '@/scss/availability_calendar_colors.scss';

.bg-spec-default {
  background-color: $calendar-accent;
}

.specialist-list-title {
  color: #36484b;
  box-shadow: 0px 3px 1px rgb(0 0 0 / 9%);
}
.specialist-list-item {
  cursor: pointer;
  border-left: 4px solid map-get($colors, 'orange');
}
.specialist-list-title-icon {
  padding: 5px 5px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.specialist-list-item-icon {
  border-radius: 30px;
  background: #fac1b7;
  height: 45px;
  width: 45px;
}
.specialist-list-item-icon-disabled {
  background: #c4c4c4;
}
.specialist-list-item-icon > i {
  padding-top: 13px;
}
.selected .specialist-list-item-icon {
  background: #869193;
}

.fs-16 {
  font-size: 16px;
}
.relative {
  position: relative;
}

.close-space {
  position: absolute;
  right: 3%;
  top: 15%;
  cursor: pointer;
}

.text-g {
  --fa-primary-color: white !important;
  --fa-secondary-color: #869193 !important;
}

.pointer {
  cursor: pointer;
}

.modal-dialog {
  position: absolute;
  z-index: 10;
  min-width: 93vw !important;
  left: 56% !important;
  transform: translateX(-58%);
  margin-top: 4px !important;
  margin-left: 2px !important;
}

.modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
  border-top: unset !important;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.border-left-orange {
  border-left: 4px solid #ff7058;
}
.specialist-license-expired {
  border-width: 1px 1px 1px 4px !important;
  border: solid #f05863;
}

.button-specialist-license-expired {
  border: 2px solid #f05863;
  background-color: #fcd9d8;
  border-radius: 4px;
  width: 34px;
  height: 34px;
}
.specialist-license-expired-icon {
  color: #f05863;
}
.bg-gray-disabled {
  background-color: #e2e2e2 !important;
}
.text-gray-disabled {
  color: #959595 !important;
}
.border-left-disabled {
  border-left: 4px solid #a2a2a2 !important;
}
.icon-disabled {
  --fa-primary-color: #c4c4c4;
  --fa-secondary-color: #959595;
}
.cursor-disabled {
  cursor: not-allowed;
}
</style>
